module.exports = __webpack_public_path__ + "static/notification2-4060178bb9113ee449233dac822fa189.png";